var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.25 7.92h-.63v-2.3a5.63 5.63 0 0 0-11.24 0v2.3h-.63a1.67 1.67 0 0 0-1.67 1.66v8.75A1.67 1.67 0 0 0 3.75 20h12.5a1.67 1.67 0 0 0 1.67-1.67V9.58a1.67 1.67 0 0 0-1.67-1.66Zm-7.92 5a1.67 1.67 0 0 1 3.34 0 1.67 1.67 0 0 1-.84 1.43v1.9a.83.83 0 0 1-1.66 0v-1.9a1.67 1.67 0 0 1-.84-1.43Zm-1.87-7.3a3.54 3.54 0 0 1 7.08 0V7.5a.42.42 0 0 1-.41.42H6.87a.42.42 0 0 1-.41-.42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.7adeed4f.svg";
export { ForwardRef as ReactComponent };